import React, { useEffect, useState } from "react";
import { URL } from "../../Redux/common/url";

const ShortsVideo = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    fetch(`${URL.API_BASE_URL}/publicApi/teamListPublic`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.success) {
          setList(data.team);
        }
      });
  }, []);

  const getEmbedUrl = (url) => {
    if (!url) return "";

    if (url.includes("shorts/"))
      return `https://www.youtube.com/embed/${url.split("shorts/")[1].split("?")[0]}`;

    if (url.includes("youtu.be/"))
      return `https://www.youtube.com/embed/${url.split("youtu.be/")[1].split("?")[0]}`;

    if (url.includes("watch?v="))
      return `https://www.youtube.com/embed/${url.split("watch?v=")[1].split("&")[0]}`;

    return "";
  };

  return (
    <div style={{ padding: "10px 0" }}>
      <div className="yt-shorts-title-left">
          <div className="yt-shorts-icon">
            <span className="yt-shorts-icon-inner" />
          </div>
          <span className="yt-shorts-text">Videos</span>
        </div>


      {/* 👉 MANUAL SLIDER */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          overflowX: "auto",        // ✅ USER scroll
          padding: "0 12px 10px",
          scrollBehavior: "smooth",
        }}
      >
        {list.map((item, index) => {
          const embedUrl = getEmbedUrl(item.video_link);
          if (!embedUrl) return null;

          return (
            <div
              key={index}
              style={{
                width: "190px",
                height: "340px",
                borderRadius: "16px",
                overflow: "hidden",
                background: "#000",
                flexShrink: 0,

                // 📱 Mobile: 2 videos visible
                maxWidth: "calc(50vw - 18px)",
              }}
            >
              <iframe
                src={embedUrl}
                width="100%"
                height="100%"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={`short-${index}`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ShortsVideo;
